// reducerUtils.js
export const handleNumberInput = (state, payload, property, defaultValue) => {
  if (payload === "") return { ...state, [property]: 0 };
  if (payload || payload === 0)
    return { ...state, [property]: Number(payload) };
  return { ...state, [property]: defaultValue };
};

export const handleIncrement = (state, property) => ({
  ...state,
  [property]: Number(state[property]) + 1,
});

export const handleDecrement = (state, property, minValue = 0) => ({
  ...state,
  [property]:
    state[property] > minValue ? Number(state[property]) - 1 : minValue,
});
